import React, { useState } from "react";
import Icon from "./Icon";
import emailjs from "@emailjs/browser";
import { SERVICE_ID, TEMPLATE_ID, PUBLIC_KEY } from "../Common/main.js";

emailjs.init(PUBLIC_KEY);
const POINTS = [
  "Tailored to your forum and practice area",
  "Trial access for your team",
  "No commitment",
];
const PRACTICES = [
  "GST & indirect tax",
  "Customs & excise",
  "Income tax",
  "Litigation & disputes",
  "Corporate & insolvency",
  "In-house legal",
];

const EMPTY = {
  name: "",
  email: "",
  phone: "",
  city: "",
  org: "",
  practice: PRACTICES[0],
};

const Contact = () => {
  const [form, setForm] = useState(EMPTY);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [sentMessage, setSentMessage] = useState("");
  const handleReset = () => {
    setForm(EMPTY);
  };
  const submit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setError("");
    setSentMessage("");

    try {
      const { name, email, phone, city, org, practice } = form;

      if (!name.trim() || !email.trim() || !phone.trim()) {
        setError("Please fill in all mandatory fields.");
        return;
      }

      const templateParams = {
        subject: `
        New Demo Request

        Name: ${name}
        Email: ${email}
        Phone: ${phone}
        City: ${city || "N/A"}
        Firm / Organisation: ${org || "N/A"}
        Practice Area: ${practice}
      `,
      };

      const result = await emailjs.send(
        SERVICE_ID,
        TEMPLATE_ID,
        templateParams,
      );

      if (result.status === 200) {
        setSentMessage("Your demo request has been submitted successfully!");
        setForm(EMPTY);
      } else {
        setError("Failed to submit your request. Please try again.");
      }
    } catch (error) {
      console.error("EmailJS Error:", error);
      setError("Failed to submit your request. Please try again.");
    } finally {
      setLoading(false);

      setTimeout(() => {
        setError("");
        setSentMessage("");
      }, 5000);
    }
  };

  return (
    <section id="contact" className="vd-section vd-section--dark">
      <div className="container">
        <div className="row g-5 align-items-center">
          <div className="col-lg-6">
            <h2 className="vd-h2">See Vedum on your own matters.</h2>
            <p className="vd-lead">
              Book a 30-minute demo. We’ll run a live research question from
              your practice area and show the brief, the insights, the draft and
              the alerts it creates.
            </p>
            <div className="vd-contact-points">
              {POINTS.map((p) => (
                <span key={p}>
                  <Icon name="check" color="#F2A33A" /> {p}
                </span>
              ))}
            </div>
          </div>
          <div className="col-lg-6">
            <form className="vd-form" onSubmit={submit}>
              <div className="row g-3">
                <div className="col-md-6">
                  <label>
                    Full name
                    <input
                      className="form-control"
                      type="text"
                      autoComplete="name"
                      value={form.name}
                      onChange={set("name")}
                      required
                    />
                  </label>
                </div>
                <div className="col-md-6">
                  <label>
                    Work email
                    <input
                      className="form-control"
                      type="email"
                      autoComplete="email"
                      value={form.email}
                      onChange={set("email")}
                      required
                    />
                  </label>
                </div>
                <div className="col-md-6">
                  <label>
                    Mobile
                    <input
                      className="form-control"
                      type="tel"
                      placeholder="+91"
                      autoComplete="tel"
                      value={form.phone}
                      onChange={set("phone")}
                    />
                  </label>
                </div>
                <div className="col-md-6">
                  <label>
                    City
                    <input
                      className="form-control"
                      type="text"
                      autoComplete="address-level2"
                      value={form.city}
                      onChange={set("city")}
                    />
                  </label>
                </div>
                <div className="col-md-6">
                  <label>
                    Firm or organisation
                    <input
                      className="form-control"
                      type="text"
                      autoComplete="organization"
                      value={form.org}
                      onChange={set("org")}
                    />
                  </label>
                </div>
                <div className="col-md-6">
                  <label>
                    Practice area
                    <select
                      className="form-select"
                      value={form.practice}
                      onChange={set("practice")}
                    >
                      {PRACTICES.map((p) => (
                        <option key={p}>{p}</option>
                      ))}
                    </select>
                  </label>
                </div>
                <div className="col-12">
                  <button
                    type="submit"
                    className="vd-btn vd-btn--primary w-100 justify-content-center"
                    disabled={loading}
                  >
                    {loading ? "Sending..." : "Book my demo"}
                  </button>
                  {error && (
                    <div className="text-danger small mt-2">{error}</div>
                  )}
                  {sentMessage && (
                    <div className="text-success small mt-2">{sentMessage}</div>
                  )}
                  <div className="small text-muted mt-2">
                    By submitting, you agree to our privacy policy. We’ll
                    respond within one business day.
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
